// extracted by mini-css-extract-plugin
export default {"next":"go-to-share_next__e+4RR","shareButton":"go-to-share_shareButton__-yqzU","disabled":"go-to-share_disabled__PFqy-"};